module.exports = __webpack_public_path__ + "static/media/icons8-google.b0277009.svg";